import BaseUIErpOrderView from 'xui/modules/order/BaseUIErpOrderView'

export default class ErpOrderView extends BaseUIErpOrderView {
  static displayName = 'ErpOrderView'
}
